module.exports = __webpack_public_path__ + "img/fm_workflow_5.f267b9b6.png";